import React, { useContext } from 'react';
import { CombinePortfoliosWizardContext } from './logic/CombinePortfoliosWizardContext';
import { cn } from '@/lib/utils';
import { DropMenu, ShimmerBlock } from 'venn-ui-kit';
import { useRecentStudio } from 'venn-utils';
import { Input } from 'venn-components';
import { getDestinationShortName, getTemplateType } from './logic/utils';

const MAX_TEMPLATES = 100;

export const TemplateStep = () => {
  const { templateSettings, setTemplateSettings, configuration } = useContext(CombinePortfoliosWizardContext);
  const { studioItems, isLoading } = useRecentStudio({
    includeTypes: [getTemplateType(configuration.destination)],
    vennTemplate: false,
    excludeVennCreated: true,
    maxSize: MAX_TEMPLATES,
  });

  const templateItems = studioItems.map(
    (item) => ({
      label: item.name,
      value: item.id,
    }),
    [studioItems],
  );

  return (
    <div className={cn('flex flex-col pl-[32px] pr-[24px] py-[40px] gap-[24px]')}>
      <div className={cn('flex flex-col')}>
        <label className={cn('font-[14px]')}>{getDestinationShortName(configuration.destination)} template</label>
        {isLoading ? (
          <div className={cn('h-[35px]')}>
            <ShimmerBlock />
          </div>
        ) : (
          <DropMenu
            placeholder="Select a template..."
            items={templateItems}
            selected={templateSettings.templateId ?? undefined}
            onChange={(item) => setTemplateSettings((current) => ({ ...current, templateId: item.value }))}
            searchable
          />
        )}
      </div>
      <div className={cn('flex flex-col')}>
        <label htmlFor="view-name" className={cn('font-[14px]')}>
          {getDestinationShortName(configuration.destination)} name (optional)
        </label>
        <Input
          id="view-name"
          value={templateSettings.templateName ?? undefined}
          onChange={(value) => setTemplateSettings((current) => ({ ...current, templateName: value }))}
          refreshedStyling
        />
      </div>
    </div>
  );
};
